<template>
	<a-drawer
	  class="settings-drawer"
	  :closable="false"
	  :visible="showProfileDrawer"
	  width="400"
	  @onAfterOpenChange="showClientInfo"
	  @close="$emit('toggleProfileDrawer', false)"
	 
	>
	  <a-button type="link" class="btn-close" @click="$emit('toggleProfileDrawer', false)">
		<svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9">
		  <g id="close" transform="translate(0.75 0.75)">
			<path id="Path" d="M7.5,0,0,7.5" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5"/>
			<path id="Path-2" data-name="Path" d="M0,0,7.5,7.5" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5"/>
		  </g>
		</svg>
	  </a-button>
	  <div class="drawer-content">
		<ProfileViewPage></ProfileViewPage>
	  </div>
	</a-drawer>
  </template>
<script>
import ProfileViewPage from '../../views/ProfileV2.1';
export default ({
	components: {
		ProfileViewPage
	},
	props: {
		// Settings drawer visiblility status.
		showProfileDrawer: {
			type: Boolean,
			default: false,
		}
	},
	data() {
		return {
			// The wrapper element to attach dropdowns to.
			wrapper: null,
		};
	},
	mounted() {
		this.getWrapper();
	},
	methods: {
		getWrapper() {
			this.$nextTick(() => {
				
				this.wrapper = document.getElementById('layout-dashboard');
			});
		},
		showClientInfo(visible) {
			if (visible) {
				console.log("entre sidebar")
				this.myCliente = this.$route.meta.myCliente
				// Aquí puedes ejecutar la función que deseas cuando el drawer se abre.
				// console.log("El drawer se ha abierto");
			}
		},
	},
});
</script>